"use client";

import { useAnimate, useReducedMotion } from "framer-motion";
import { type ReactNode, useEffect } from "react";

import { tileFlyInConfig } from "@/lib/animations";

const STAGGER_DELAY = 0.07;

interface FlyInChipProps {
  index: number;
  children: ReactNode;
  className?: string;
}

export function FlyInChip({ index, children, className }: FlyInChipProps) {
  const prefersReduced = useReducedMotion();
  const [scope, animate] = useAnimate<HTMLDivElement>();

  useEffect(() => {
    if (!scope.current) return;
    if (prefersReduced) {
      animate(scope.current, { opacity: 1 }, { duration: 0 });
      return;
    }
    const delay = index * STAGGER_DELAY;
    animate(scope.current, { scale: tileFlyInConfig.scale }, { duration: 0 }).then(() => {
      if (!scope.current) return;
      animate(scope.current, { opacity: 1, scale: 1 }, { ...tileFlyInConfig.transition, delay });
    });
  }, [animate, index, prefersReduced, scope]);

  return (
    <div ref={scope} className={className} style={{ opacity: 0 }}>
      {children}
    </div>
  );
}
